import _slicedToArray from "E:/code/nkyOrder/trunk/vantCommon/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "E:/code/nkyOrder/trunk/vantCommon/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.pad-start.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getQueueregistByPatientid as _getQueueregistByPatientid, getQuestionnaireListByPatientid, getQuestionnaireAnswer as _getQuestionnaireAnswer } from '@/api/module/index';
import { decrypt } from '../../assets/utils/cryptoUtil.js';
export default {
  name: "index",
  data: function data() {
    return {
      active: 0,
      quests: [],
      questList: [],
      typeid: '',
      answers: [],
      answerShow: false,
      filterShow: false,
      show: false,
      startDate: null,
      endDate: null,
      iconColor: '#000000',
      screenTimeShow: 1,
      categoryShow: 1,
      noDataShow: false
    };
  },
  created: function created() {
    this.getQuestionnaireList();
    this.screenTime(this.screenTimeShow); // this.getQuestionnaireTypeID()
  },
  filters: {
    serialnoFilter: function serialnoFilter(serialno) {
      if (serialno && serialno != '') {
        return decrypt(serialno);
      } else {
        return "";
      }
    }
  },
  methods: {
    toDetail: function toDetail(item) {
      this.$router.push({
        name: 'preconsultationDetail',
        query: {
          id: item.id,
          serialno: item.serialno,
          bookedNo: item.bookedNo,
          typeid: item.typeid
        }
      });
    },
    // toAnswer(serialno){
    //   this.$router.push({name: 'preconsultationAnswer',query: {serialno:serialno}})
    // },
    //题目和答案
    getQuestionnaireAnswer: function getQuestionnaireAnswer(item) {
      var _this = this;

      var param = {
        bookedNo: item.bookedNo,
        serialno: item.serialNo,
        typeid: item.typeID,
        outsideNo: item.outsideNo
      };

      _getQuestionnaireAnswer(param).then(function (res) {
        if (res.code == 200) {
          _this.answers = res.data;
          _this.answerShow = true;
        }
      });
    },
    //切换
    toggle: function toggle() {
      if (this.active == 0) {
        //查询进行中的
        this.quests = this.questList.filter(function (item) {
          return (item.status == "1" || item.status == "2") && item.typeName == "体检检前问卷";
        });

        if (this.quests.length <= 0) {
          this.getQueueregistByPatientid();
        }
      } else if (this.active == 1) {
        //查询已完成的
        this.quests = this.questList.filter(function (item) {
          return item.status == "3";
        });
      } else if (this.active == 2) {
        this.getQueueregistByPatientid();
      }
    },
    getQuestionnaireList: function getQuestionnaireList() {
      var _this2 = this;

      var loginuser = JSON.parse(localStorage.getItem("loginuser"));
      var param = {
        patientid: loginuser.patientid,
        startDate: this.startDate,
        endDate: this.endDate
      };
      getQuestionnaireListByPatientid(param).then(function (res) {
        if (res.code == 200) {
          _this2.questList = res.data;

          _this2.toggle();
        }
      });
    },
    getQueueregistByPatientid: function getQueueregistByPatientid() {
      var _this3 = this;

      var loginuser = JSON.parse(localStorage.getItem("loginuser"));
      var param = {
        patientid: loginuser.patientid
      };

      _getQueueregistByPatientid(param).then(function (res) {
        _this3.noDataShow = true;

        if (res.code == 200) {
          if (res.data.length > 0) {
            _this3.quests = res.data;
          } else {
            _this3.quests = [];
          } // 全部 分类筛选


          if (_this3.active == '2') {
            var _this3$quests;

            var queryList = _this3.questList.filter(function (item) {
              if (_this3.categoryShow == 2 && item.typeName == "体检检前问卷") {
                return item;
              } else if (_this3.categoryShow == 3 && item.typeName == "满意度调查问卷") {
                return item;
              } else if (_this3.categoryShow == 4 && item.category == "03") {
                return item;
              } else if (_this3.categoryShow == 1) {
                return item;
              }
            });

            (_this3$quests = _this3.quests).push.apply(_this3$quests, _toConsumableArray(queryList));
          }
        }
      });
    },
    filter: function filter() {
      this.filterShow = true;
    },
    formatDate: function formatDate(date) {
      return "".concat(date.getFullYear(), "-").concat(date.getMonth() + 1, "-").concat(date.getDate());
    },
    onConfirm: function onConfirm(date) {
      var _date = _slicedToArray(date, 2),
          start = _date[0],
          end = _date[1];

      this.show = false;
      this.screenTimeShow = 0;
      this.startDate = "".concat(this.formatDate(start));
      this.endDate = "".concat(this.formatDate(end));
    },
    filterClose: function filterClose(item) {
      this.filterShow = false;

      if (item == 0) {
        this.categoryShow = 1;
        this.screenTimeShow = 1;
        this.startDate = null;
        this.endDate = null;
        this.iconColor = '#000000';
        this.getQuestionnaireList();
      } else {
        this.iconColor = '#1989fa';
        this.getQuestionnaireList();
      }
    },
    screenTime: function screenTime(item) {
      this.screenTimeShow = item; // 输出结果

      this.startDate = this.getTime(item);
      this.endDate = this.getTime(0);
    },
    getTime: function getTime(item) {
      // 获取当前时间
      var currentDate = new Date(); // 往后推一年

      var formattedDate = currentDate.getFullYear() - item + '-' + (currentDate.getMonth() + 1).toString().padStart(2, '0') + '-' + currentDate.getDate().toString().padStart(2, '0');
      return formattedDate;
    },
    category: function category(item) {
      this.categoryShow = item;
    }
  }
};